import React, {
  useState,
  useEffect,
} from 'react';
import { withRouter } from 'react-router-dom';
import {
  Box,
  Container,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import Page from '../../../components/Layout/Page';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import DeveloperEditForm from './DeveloperEditForm';
import Header from './Header';
import Request from '../../../requests/api/developer';
import useStyles from './styles';

function DeveloperEditView(props) {
  const classes = useStyles();
  const isMountedRef = useIsMountedRef();
  const [developer, setDeveloper] = useState();

  useEffect(() => {
    const getDeveloper = async () => {
      const res = await Request.getDeveloperById(props.match.params.id);
      const response = res.data;
      if (isMountedRef.current) {
        setDeveloper(response.data.developer);
      }
    };

    getDeveloper();
    // eslint-disable-next-line
  }, [props]);

  if (!developer) {
    return null;
  }

  return (
    <Page
      className={classes.root}
      title="Editar Developer"
    >
      <Container maxWidth="lg">
        <Header />
        <Box mt={3}>
          <DeveloperEditForm developer={developer} />
        </Box>
      </Container>
    </Page>
  );
}

DeveloperEditView.propTypes = {
  match: PropTypes.any,
};

export default withRouter(DeveloperEditView);
